// types
import { MenuProps } from 'types/menu';
import { createSlice } from '@reduxjs/toolkit';

// initial state
const initialState: MenuProps = {
    selectedItem: [''],
    menuItem: [],
    drawerOpen: true,
    actionData: [],
    menuItemsList: [],
    openedForm: null,
    openedAction: null
};

// ==============================|| SLICE - MENU ||============================== //

const menu = createSlice({
    name: 'menu',
    initialState,
    reducers: {
        activeItem(state, action) {
            state.selectedItem = action.payload;
        },

        activeMenuItem(state, action) {
            state.menuItem = action.payload;
        },

        saveActionData(state, action) {
            state.actionData = action.payload;
        },

        openDrawer(state, action) {
            state.drawerOpen = action.payload;
        },
        saveMenuItemList(state, action) {
            state.menuItemsList = action.payload;
        },
        activeForm(state, action) {
            state.openedForm = action.payload;
        },
        activeAction(state, action) {
            state.openedAction = action.payload;
        },
        cleanOpenedAction(state) {
            state.openedAction = null;
        }
    }
});

export default menu.reducer;

export const { activeItem, openDrawer, activeMenuItem, saveActionData, saveMenuItemList, activeForm, activeAction, cleanOpenedAction } =
    menu.actions;
